import { CheckCircleIcon, InformationCircleIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"

export default function Message(props) {

    const { type = 'default', display, className } = props

    const messageClass = classNames('message', `message-${type}`, className, {
        'show': display,
    })
    
    return (
        <div className={messageClass}>
            <div className="icon">
                { (type === 'info' || type === 'default') &&
                    <InformationCircleIcon />
                }
                { type === 'error' &&
                    <InformationCircleIcon />
                }
                { type === 'success' &&
                    <CheckCircleIcon />
                }
            </div>
            <div>
                { props.children}
            </div>
        </div>
    )
}